const keyList = {
  symbols: "xt.symbols", //市场列表，{version: "", symbols: []}
  currencies: "xt.currencies", //币种列表，{version: "", currencies: []}
  loginType: "loginType", //登录方式，email 或 mobile
  country: "country", //国家存储
  colorReverse: "colorReverse", //红绿偏好设置，0=绿涨红跌，1=红涨绿跌
  "client-device-id": "client-device-id", //设备id
  lastLoginAccount: "xt.userCenter.lastLoginAccount", //上次登录账户，{type: "email", userName: "abc@gmail.com"}
  assetsNavCollapse: "xt.userCenter.assetsNavCollapse", //资产页面是否折叠
  hideFund: "hideFund", //是否隐藏资产
  hideSmallAll: "hideSmallAll", //是否隐藏0资产账户
  hideSmallSpot: "hideSmallSpot", //现货-是否隐藏0资产
  hideSmallMargin: "hideSmallMargin", //杠杆-是否隐藏0资产
  hideSmallFuture: "hideSmallFuture", //合约-是否隐藏0资产
  assetsFutureCode: "assetsFutureCode", //资产-合约账户，哪种合约类型 FUTURES_U | FUTURES_C
  assetConvert: "assetConvert", //显示资产，BTC 或 USDT
  withdrawTip: "withdrawTip",
  currencyList: "currencyList",
  xtSmartChain: "xtSmartChain",
  withdrawalCurrencyTips: "withdrawalCurrencyTips",
  depositeTipArr: "depositeTipArr",
};

export default {
  keyList,
  get(key) {
    if (typeof window === "undefined") return;
    const itemKey = keyList[key];
    if (!itemKey) return console.log("%c$storage.get 键名不在列表内: %c" + key, "color: #ac2925", "color: red");

    const itemValue = localStorage.getItem(itemKey);
    let result;
    try {
      result = JSON.parse(itemValue);
    } catch (e) {
      result = itemValue;
    }
    return result || "";
  },
  set(key, value) {
    if (typeof window === "undefined") return;
    const itemKey = keyList[key];
    if (!itemKey) return console.log("%c$storage.set 键名不在列表内: %c" + key, "color: #ac2925", "color: red");

    try {
      localStorage.setItem(itemKey, JSON.stringify(value));
    } catch (e) {
      localStorage.setItem(itemKey, value);
    }
  }, //对象会被压成字符串
  remove(key) {
    if (typeof window === "undefined") return;
    const itemKey = keyList[key];
    if (!itemKey) return console.log("%c$storage.remove 键名不在列表内: %c" + key, "color: #ac2925", "color: red");

    localStorage.removeItem(itemKey);
  },
  clear() {
    if (typeof window === "undefined") return;
    localStorage.clear();
    return true;
  },
};
